export const ContactLookup = {
  Email: 'levitatetherapy@gmail.com',
  Phone: '07840 088726',
};
